import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const About = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
     

      {/* Overview Paragraph */}
      <Box component="main" sx={{ p: 4, textAlign: 'center' }}>
              <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('about.title', 'What is Vison Zero?')}
      </Typography>
        <Typography
          variant="body1"
          sx={{
            maxWidth: '800px',
            mx: 'auto',
            textAlign: 'justify',
            fontSize: { xs: '1rem', sm: '1.25rem' },
            lineHeight: 1.6,
          }}
        >
          {t('about.description')}
        </Typography>
      </Box>

{/* Why vision zero Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '400px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      boxSizing: 'border-box',
      bgcolor: '#33834a',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('about.why_vision_zero_title', 'Action')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('about.why_vision_zero_text')}
      </Typography>

{/*       <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('about.why_vision_zero_button', 'Crash Dashboard')}
        </Button>
      </Box> */}
    </Box>
  </Box>


{/* Right Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/about-why-vision-zero.jpg`}
    alt={t('why_vision_zero_img_alt', 'why vision zero')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>

</Box>
{/* Embedded Dashboard */}
<Box
  sx={{
    width: '100%',
    height: { xs: '400px', md: '600px' }, // responsive heights
    my: 0, // margin top/bottom
  }}
>
  <Box
    component="iframe"
    src="https://www.arcgis.com/apps/dashboards/200864f6f9ef48b0870dd89a38be2a0d" // <-- replace with your site
    title="Embedded Website"
    sx={{
      width: '100%',
      height: '100%',
      border: 'none',
    }}
  />
</Box>


      {/* Action Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: 'auto',
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '400px', md: '5' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/about-action.jpg`}
    alt={t('about.action_image_alt', 'Action')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity to taste
    }}
  />
</Box>


  {/* Right Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      bgcolor: '#ffb606',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('about.action_title', 'Action')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t(
          'about.action_text'        )}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
           onClick={() => {
  navigate('/miami-lakes-actions');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('about.action_button', 'Take Action')}
        </Button>
      </Box>
    </Box>
  </Box>
</Box>


{/* Comprehensive Vision Zero Safety Action Plan Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '600px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      boxSizing: 'border-box',
      bgcolor: '#00b9c4',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('about.comprehensive_plan_title', 'Comprehensive Vision Zero Safety Action Plan')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('about.comprehensive_plan_text')}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
           onClick={() => {
  navigate('/miami-lakes-public-input');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('about.comprehensive_plan_button', 'Get Involved')}
        </Button>
      </Box>
    </Box>
  </Box>


{/* Right Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '600px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/about-comprehensive-plan.jpg`}
    alt={t('comprehensive_plan_img_alt', 'Comprehensive')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>

</Box>


      {/* Public Input Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: 'auto',
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '400px', md: '5' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/about-public-input.jpg`}
    alt={t('about.public_input_image_alt', 'Public Input')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity to taste
    }}
  />
</Box>


  {/* Right Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      bgcolor: 'white',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('about.public_input_title', 'Public Input')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t(
          'about.public_input_text'        )}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
                     onClick={() => {
  navigate('/miami-lakes-public-input');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('about.public_input_button', 'Public Input')}
        </Button>
      </Box>
    </Box>
  </Box>
</Box>


{/* High Crash Network Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '600px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      boxSizing: 'border-box',
      bgcolor: '#00539b',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('about.high_crash_title1', 'Action')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('about.high_crash_text1')}
      </Typography>
      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' }, fontWeight: 'bold' }}>
        {t('about.high_crash_title2')}
      </Typography>
            <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('about.high_crash_text2')}
      </Typography>
      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' }, fontWeight: 'bold' }}>
        {t('about.high_crash_title3')}
      </Typography>
            <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('about.high_crash_text3')}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('about.high_crash_button', 'High Crash Network')}
        </Button>
      </Box>
    </Box>
  </Box>


{/* Right Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '600px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/about-high-crash.jpg`}
    alt={t('high_crash_img_alt', 'High Crash')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>

</Box>







    </div>
  );
};

export default About;
